import './App.css';
import './Aos.css';
import './Main.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// View Pages
import Navbar from './view/Navbar';
import HeroCarousel from './view/HeroCarousel';
import AboutHome from './view/AboutHome';
import ProductCategory from './view/ProductCategory';
import Footer from './view/Footer';
import Contact from './view/Contact';
import Product from './view/Product';
import ProductDetails from './view/ProductDetails';
import About from './view/About';
import CoreValue from './view/CoreValue';
import ScrollToTop from './view/ScrollToTop';




function Home() {
  return (
    <>
      <Helmet>
        <title>Railing World</title>
        <meta
          name="description"
          content="Railing World offers aluminum, glass, and stainless steel railings with custom design solutions for homes and businesses across India."
        />
        <meta
          name="keywords"
          content="Railing World, Railing Manufacturer, Aluminum Railings, Stainless Steel Railing, Glass Balcony, Rajkot Railings"
        />
        <link rel="canonical" href="https://www.railingworld.in/" />
      </Helmet>
      <HeroCarousel />
      <AboutHome />
      {/* <ClientDetail /> */}
      <CoreValue />
    </>
  );
}

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/category" element={<ProductCategory />} />
        <Route path="/product" element={<Product />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/:id" element={<ProductDetails />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;